/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/media-has-caption */
import { useRef, useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { createUseStyles } from 'react-jss'
import ally from 'ally.js'
import gsap from 'gsap'
import ModalGallery from '@/components/ModalGallery'
import actions from '@/actions'
import style from './style'

const useStyles = createUseStyles(style)

const Modal = ({
  modalOpen,
  modalData,
  setModalOpen,
}) => {
  const classes = useStyles(style)
  const $root = useRef()
  const $content = useRef()
  const $close = useRef()
  const $video = useRef()
  const [content, setContent] = useState('')
  const disableAllTabIndex = useRef(null)

  /*------------------------------
  Close Modal
  ------------------------------*/
  const closeModal = () => {
    setModalOpen(false)
    setContent('')
  }

  /*------------------------------
  Content
  ------------------------------*/
  useEffect(() => {
    if (modalData) {
      const { type } = modalData

      switch (type) {
        case 'gallery':
          setContent(
            <ModalGallery
              gallery={modalData.gallery}
              initialSlide={modalData.initialSlide}
            />,
          )
          break
        case 'video':
          setContent(
            <div className={classes.videoWrap} onClick={() => { closeModal() }}>
              <video ref={$video} playsInline className={classes.video}>
                <source type="video/mp4" src={modalData.video} />
              </video>
            </div>,
          )
          setTimeout(() => {
            $video.current.currentTime = 0
            $video.current.play()
          }, 200)
          break
        default:
      }
    }
  }, [modalData])

  /*------------------------------
  HandleKeyboard
  ------------------------------*/
  const handleKeyboard = (e) => {
    // Esc = 27
    if (e.which === 27) {
      closeModal()
    }
  }

  /*------------------------------
  Events
  ------------------------------*/
  const events = () => {
    window.addEventListener('keydown', handleKeyboard)
  }

  /*------------------------------
  Destroy Events
  ------------------------------*/
  const destroyEvents = () => {
    window.removeEventListener('keydown', handleKeyboard)
  }

  /*------------------------------
  Apri Chiudi
  ------------------------------*/
  useEffect(() => {
    if (modalOpen === true) {
      gsap.to($root.current, {
        duration: 0.5,
        autoAlpha: 1,
        display: 'block',
      })
      gsap.fromTo($close.current, {
        rotation: -90,
        scale: 0.5,
      }, {
        duration: 0.6,
        rotation: 0,
        scale: 1,
        ease: 'power3.out',
      })

      events()
    } else {
      gsap.to($root.current, {
        duration: 0.5,
        autoAlpha: 0,
        display: 'none',
      })
      gsap.to($close.current, {
        duration: 0.6,
        rotation: 90,
        scale: 0.5,
        ease: 'power3.out',
      })

      destroyEvents()
    }
  }, [modalOpen])

  /*------------------------------
  HandleClose
  ------------------------------*/
  const handleClose = () => {
    closeModal()
  }

  /*------------------------------
  Enable keyboard navigation only in modal
  ------------------------------*/
  useEffect(() => {
    if (modalOpen) {
      disableAllTabIndex.current = ally.maintain.disabled({
        filter: $root.current,
      })
    }
    if (!modalOpen && disableAllTabIndex.current !== null) disableAllTabIndex.current.disengage()
  }, [modalOpen])

  /*------------------------------
  Render
  ------------------------------*/
  return (
    <div
      className={classes.root}
      ref={$root}
      role="dialog"
      aria-modal="true"
    >
      <button
        className={classes.close}
        onClick={handleClose}
        ref={$close}
        aria-label="close-modal"
        tabIndex={modalOpen ? 0 : -1}
      >
        <svg>
          <use xlinkHref="#ico-close" />
        </svg>
      </button>
      <div className={classes.content} ref={$content}>
        {content}
      </div>
    </div>
  )
}

Modal.defaultProps = {
  modalData: {},
}

const mapStateToProps = (state) => ({
  modalOpen: state.modal.open,
  modalData: state.modal.data,
})

const mapDispatchToProps = (dispatch) => ({
  setModalOpen: (bool) => { dispatch(actions.modal.setOpen(bool)) },
})

export default connect(mapStateToProps, mapDispatchToProps)(Modal)
